import axios from 'axios';
import API_CONFIG from '../config/api';
import { getAuthHeaders } from '../utils/auth';

const authService = {
  // Login admin
  login: async (email, password) => {
    try {
      const response = await axios.post(`${API_CONFIG.BASE_URL}/auth/login`, {
        email,
        password,
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Login failed' };
    }
  },

  // Verify token
  verifyToken: async () => {
    try {
      const response = await axios.get(`${API_CONFIG.BASE_URL}/auth/verify`, {
        headers: getAuthHeaders(),
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Token verification failed' };
    }
  },

  // Logout (optional server-side call)
  logout: async () => {
    try {
      const response = await axios.post(
        `${API_CONFIG.BASE_URL}/auth/logout`,
        {},
        {
          headers: getAuthHeaders(),
        }
      );
      return response.data;
    } catch (error) {
      // Even if server call fails, we still clear the token client-side
      console.error('Logout error:', error);
      return { success: true };
    }
  },

  // Change password
  changePassword: async (currentPassword, newPassword) => {
    try {
      const response = await axios.post(
        `${API_CONFIG.BASE_URL}/auth/change-password`,
        {
          currentPassword,
          newPassword,
        },
        {
          headers: getAuthHeaders(),
        }
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Password change failed' };
    }
  },
};

export default authService;

